import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";

import cls from "classnames";

import { withTitle, withAuth } from "../../HoC";
import { registrationURL } from "../../utils/constants";
import { socketManager } from "../../services/socketService/socketManager";
import { generateUniqueId } from "../../utils/uuid4";
import { withMessageOverlay } from "../../HoC/withTimeoutOverlay";
import { postRequest } from "../../services/Requests";

import { QRCodeComponent } from "../../Components/QRCode";

import { Footer } from "../../Components/Footer/Footer";

import style from "./device.module.scss";
import { Confirmation } from "../../Components/Confirmed/Confirmation";
import { translate } from "../../translations/translate";
import { Header } from "../../Components/Header/Header";

export const DevicePage = (props) => {

  const {
    socketReducer,
    match,
    devices = [],
  } = props;

  const {
    remaining,
    isConnected,
    maxReached = false,
    queue,
  } = socketReducer;

  const {
    id: deviceId,
    uuid,
  } = devices.find((e) => e.uuid === match.params.deviceId) || {};

  if (!deviceId) {
    props.history.push("/admin");
  }

  const [ result, setResult ] = useState<{ isOpen: boolean, loading: boolean, data: any }>({ isOpen: false, loading: false, data: {} });

  const registerBooking = () => {
    setResult({ isOpen: true, loading: true, data: {} });
    postRequest({
      url: `register/${uuid}`,
      body: {
        email: "",
        timeOffset: 600000,
      },
    }).then(({ data }: any) => {
      setResult({ isOpen: true, loading: false, data });
      setTimeout(() => {
        setResult({ isOpen: false, loading: false, data: {}});
      }, 4000);
    }).catch((er) => {
      console.warn(er);
    });
  };

  useEffect(() => {
    const randomId = generateUniqueId();
    socketManager.init({ deviceId, uid: randomId });
    return () => socketManager.close();
  }, []);

  return (<div className={style["wrapper"]}>
    <Header withCode />
    <section className={cls(style["section"], { [style["danger"]]: maxReached })}>
      <div className={cls(style["text-wrapper"])}>
        {maxReached ?
          (<>
          <h1 className={style["text"]} > {translate("max-capacity")} </h1>
          <h1 className={style["text"]} > {translate("wait")} </h1>
          </>) : (
          <>
          <h1 className={style["text"]}> {translate("access-to")} </h1>
          <h1 className={style["numba"]}> {remaining} </h1>
          <h1 className={style["text"]}> {remaining > 1 ? translate("person.mult") : translate("person.sing") }</h1>
          </>
        )}
      </div>
      <div className={style["queue-wrapper"]}>
          <div className={cls(style["qrcode"], { [style["bg-white"]]: maxReached })}>
            {maxReached ?
            (<>
              <h3> {translate("scan-code-text")} </h3>
              <QRCodeComponent width={100} onClick={registerBooking} text={`${registrationURL}${uuid}`} />
            </>) : (<>
                <h3 className={style["enter-text"]}> {translate("next-enter")} </h3>
            </>)}
          </div>
          <div className={style["queue"]}>
              {queue.map(({ orderNumber, id }) => (<h3 key={id}> {orderNumber} </h3>))}
          </div>
      </div>
    </section>
    {result.isOpen ? <div className={cls(style["overlay"])}>
      <Confirmation
        loading={result.loading}
        orderNumber={result.data.orderNumber}
        startDate={result.data.startDate}
        withMapButton={false}
      />
    </div> : null}
    <Footer isConnected={isConnected} />
  </div>);
};

const mapStateToProps = (state: { deviceReducer: any, socketReducer: any, adminReducer: any }) => ({
  deviceReducer: state.deviceReducer,
  socketReducer: state.socketReducer,
  devices: state.adminReducer.devices,
});

export default compose(
  withTitle(translate("gate")),
  withAuth(0),
  connect(mapStateToProps),
  withMessageOverlay(
    translate("out-of-service"),
    translate("out-of-service-temp"),
  ),
)(DevicePage);
